var path = 'components/shows/tooltips/showsNetworksNames.html';
var html = "<div class=tooltip-list> <div ng-repeat=\"name in show._networksNames() | orderBy track by $index\" ng-bind=name></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;